import { Link } from 'react-router-dom';
import Segment from '../shared/segment';

function StudentExamsHeader() {
  return (
    <Segment bg color='green' textAlign='center' className='flex flex-col gap-4'>
      <h1 className='text-xl font-medium'>آزمون‌های انجام شده</h1>
      <p>
        <span>برای دیدن </span>
        <span className='font-medium'>"آزمون‌های در دسترس"</span>
        <span> از منوی </span>
        <Link to='/exams' className='font-medium text-blue-700'>
          آزمون‌ها
        </Link>
        <span> استفاده کنید.</span>
      </p>
    </Segment>
  );
}

export default StudentExamsHeader;
